const products = [
  {
    id: 1,
    name: "Bamboo Toothbrush",
    price: 249,
    description: "Biodegradable toothbrush made from bamboo.",
    isEcoFriendly: true,
    imageUrl:
      "https://images.pexels.com/photos/5420478/pexels-photo-5420478.jpeg?auto=compress&cs=tinysrgb&w=600",
    coins: [
      {
        id: "coin1",
        name: "EcoCoin",
        symbol: "ECO",
        value: 25,
      },
    ],
  },
  {
    id: 2,
    name: "Reusable Straw Set",
    price: 599,
    description: "Set of 4 stainless steel straws with cleaning brush.",
    isEcoFriendly: true,
    imageUrl: "https://images.pexels.com/photos/7262893/pexels-photo-7262893.jpeg?auto=compress&cs=tinysrgb&w=600",
    coins: [
      {
        id: "coin2",
        name: "EcoCoin",
        symbol: "ECO",
        value: 60,
      },
    ],
  },
  {
    id: 3,
    name: "Glass Water Bottle",
    price: 899,
    description: "Durable and reusable glass water bottle.",
    isEcoFriendly: true,
    imageUrl: "https://images.pexels.com/photos/4159894/pexels-photo-4159894.jpeg?auto=compress&cs=tinysrgb&w=600",
    coins: [
      {
        id: "coin3",
        name: "EcoCoin",
        symbol: "ECO",
        value: 90,
      },
    ],
  },
  {
    id: 4,
    name: "Cotton Tote Bag",
    price: 399,
    description: "Reusable and stylish cotton tote bag.",
    isEcoFriendly: true,
    imageUrl: "https://images.pexels.com/photos/7262778/pexels-photo-7262778.jpeg?auto=compress&cs=tinysrgb&w=600",
    coins: [
      {
        id: "coin4",
        name: "EcoCoin",
        symbol: "ECO",
        value: 40,
      },
    ],
  },
  {
    id: 5,
    name: "Beeswax Food Wraps",
    price: 799,
    description: "Sustainable alternative to plastic wrap for food storage.",
    isEcoFriendly: true,
    imageUrl: "https://images.pexels.com/photos/4235860/pexels-photo-4235860.jpeg?auto=compress&cs=tinysrgb&w=600",
    coins: [
      {
        id: "coin5",
        name: "EcoCoin",
        symbol: "ECO",
        value: 80,
      },
    ],
  },
];

export default products;
